export default "__VITE_ASSET__BbnMZjBQ__"